<template>
  <div class="container video-page-container">
    <div class="columns video-top-info">
      <div class="column is-9">
        <h1>{{ video.pagetitle }}</h1>
        <h5>
          <span>{{ current.label }}</span>
          עם
          <teacher-tag
            v-if="teacher && teacher.id"
            :teacher="teacher"
            :base="initialData.basepath"
            :className="current.alias"
          ></teacher-tag>
          <svg style="width: 16px; height: 16px" viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M12 20C16.4 20 20 16.4 20 12S16.4 4 12 4 4 7.6 4 12 7.6 20 12 20M12 2C17.5 2 22 6.5 22 12S17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2M17 13.9L16.3 15.2L11 12.3V7H12.5V11.4L17 13.9Z"
            />
          </svg>
          {{ video.videoDuration }} דקות
          <svg
            class="level-icon"
            viewBox="0 0 22 22"
            v-if="video.videoLvl === '1'"
          >
            <path
              fill="currentColor"
              d="M19.5,5.5V18.5H17.5V5.5H19.5M12.5,10.5V18.5H10.5V10.5H12.5M21,4H16V20H21V4M14,9H9V20H14V9M7,14H2V20H7V14Z"
            />
          </svg>
          <svg
            class="level-icon"
            viewBox="0 0 22 22"
            v-if="video.videoLvl === '2'"
          >
            <path
              fill="currentColor"
              d="M19.5,5.5V18.5H17.5V5.5H19.5M21,4H16V20H21V4M14,9H9V20H14V9M7,14H2V20H7V14Z"
            />
          </svg>
          <svg
            class="level-icon"
            viewBox="0 0 22 22"
            v-if="video.videoLvl === '3'"
          >
            <path
              fill="currentColor"
              d="M21,4H16V20H21V4M14,9H9V20H14V9M7,14H2V20H7V14Z"
            />
          </svg>
          <span> רמה {{ video.videoLvl }}</span>
        </h5>
        <div v-html="video.content" class="video-content">
          {{ video.content }}
        </div>

        <equip-item :list="equipment" :base="initialData.basepath"></equip-item>
      </div>
      <div class="column is-3 has-text-left">
        <like-teacher :teacher="teacher"></like-teacher>
        <teacher-imglink
          :teacher="teacher"
          v-if="teacher && teacher.id"
        ></teacher-imglink>
      </div>
      <div class="video-tags">
        <div class="column is-9">
          <div class="result-tag" v-for="(tag, index) in tagList" :key="index">
            <span class="hash">#</span>
            <span>{{ tag }}</span>
          </div>
        </div>
        <div class="column is-3 has-text-left">
          <star-video :video="video"></star-video>
          <was-watched :video="video.id"></was-watched>
        </div>
      </div>
    </div>

    <div class="main-video-container">
      <main-video2
        v-if="video && initialData && video.kalturaId !== ''"
        :video="video"
        :base="initialData.basepath"
      ></main-video2>

      <main-video
        v-else
        :video="video"
        :base="initialData.basepath"
      ></main-video>
    </div>
    <!-- end main-video-container -->
    <div class="more-videos">
      <h2>שיעורים נוספים</h2>
      <videos :videos="moreVideosToShow"></videos>
      <div class="load-more" v-if="page * 4 < moreVideos.length">
        <a href="#" @click.prevent="page += 1">
          <svg
            width="20"
            height="20"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.58366 4.08366H6.41699V6.41699H4.08366V7.58366H6.41699V9.91699H7.58366V7.58366H9.91699V6.41699H7.58366V4.08366ZM7.00033 1.16699C3.78033 1.16699 1.16699 3.78033 1.16699 7.00033C1.16699 10.2203 3.78033 12.8337 7.00033 12.8337C10.2203 12.8337 12.8337 10.2203 12.8337 7.00033C12.8337 3.78033 10.2203 1.16699 7.00033 1.16699ZM7.00033 11.667C4.42783 11.667 2.33366 9.57283 2.33366 7.00033C2.33366 4.42783 4.42783 2.33366 7.00033 2.33366C9.57283 2.33366 11.667 4.42783 11.667 7.00033C11.667 9.57283 9.57283 11.667 7.00033 11.667Z"
              fill="currentColor"
            />
          </svg>

          הראה לי עוד
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import MainVideo from "@/components/video_page/MainVideo.vue";
import MainVideo2 from "@/components/video_page/MainVideo2.vue";
import TeacherTag from "@/components/TeacherTag_v2.vue";
import CurrentTag from "@/components/CurrentTag_v2.vue";
import EquipItem from "@/components/video_page/EquipItem_v2.vue";
import Videos from "@/components/Videos.vue";
import StarVideo from "@/components/video_page/StarVideo_v2.vue";
import TeacherImglink from "@/components/teachers/TeacherImglink.vue";
import LikeTeacher from "@/components/teachers/LikeTeacher.vue";
import WasWatched from "@/components/video_page/wasWatchedTag.vue";

export default {
  name: `VideoPage`,
  data() {
    return {
      video: {},
      current: { cid: 1 },
      teacher: { tid: 1 },
      equipment: [],
      page: 1,
    };
  },

  components: {
    MainVideo,
    MainVideo2,
    TeacherTag,
    CurrentTag,
    EquipItem,
    Videos,
    StarVideo,
    TeacherImglink,
    LikeTeacher,
    WasWatched,
  },

  beforeRouteEnter(to, from, next) {
    axios
      .get(`${process.env.VUE_APP_API_VIDEOLIST}`, {
        params: { vid: `${to.params.vid}` },
      })
      .then((res, error) => {
        next(vm => {
          vm.setData(res.data, error);

          vm.getCurrent();
          vm.getTeacher();
          vm.getEquipList();
          window.scrollTo(0, 0);
        });
      });
  },

  beforeRouteUpdate(to, from, next) {
    this.equipment = [];
    axios
      .get(`${process.env.VUE_APP_API_VIDEOLIST}`, {
        params: { vid: `${to.params.vid}` },
      })
      .then((res, error) => {
        this.setData(res.data, error);
        this.getCurrent();
        this.getTeacher();
        this.getEquipList();
        window.scrollTo(0, 0);
      });
    next();
  },

  watch: {
    initialData() {
      this.getCurrent();
      this.getTeacher();
      this.getEquipList();
    },
  },

  computed: {
    initialData() {
      return this.$store.state.initialData;
    },
    teacherVideos() {
      let videos = [];
      if (Array.isArray(this.$store.state.videos)) {
        videos = this.$store.state.videos.filter(video => {
          if (video.videoTeacher === this.teacher.id) {
            return true;
          }
          return false;
        });
      }
      return videos;
    },
    currentVideos() {
      let cur = [];
      if (Array.isArray(this.$store.state.videos)) {
        cur = this.$store.state.videos.filter(v => {
          if (!v.id || !this.teacher.id) {
            return false;
          }
          if (
            v.current === this.current.resource.id &&
            v.videoTeacher !== this.teacher.id
          ) {
            return true;
          }
          return false;
        });
      }
      return cur;
    },
    moreVideos() {
      if (this.teacherVideos.length > 7) {
        return this.teacherVideos;
      }
      return [...this.teacherVideos, ...this.currentVideos];
    },
    moreVideosToShow() {
      return this.moreVideos.slice(0, 4 * this.page);
    },
    level() {
      if (Array.isArray(this.$store.state.initialData.levels)) {
        const arr = this.$store.state.initialData.levels.filter(l => {
          if (l.value === this.video.videoLvl) {
            return true;
          }
          return false;
        });
        if (arr[0]) {
          return arr[0].label;
        }
      }
      return ``;
    },

    tagList() {
      let output = [];
      if (this.video.tempo) {
        this.video.tempo.split("||").forEach(item => {
          if (item) {
            output.push(this.getTag(item, this.$store.state.initialData.tempo));
          }
        });
      }
      if (this.video.focus) {
        this.video.focus.split("||").forEach(item => {
          if (item) {
            output.push(
              this.getTag(item, this.$store.state.initialData.focusList)
            );
          }
        });
      }
      if (this.video.bodyPart) {
        this.video.bodyPart.split("||").forEach(item => {
          if (item) {
            output.push(
              this.getTag(item, this.$store.state.initialData.bodyPart)
            );
          }
        });
      }

      return output;
    },

    isLoggedIn() {
      return this.$store.state.user.isLoggedIn;
    },
  },

  methods: {
    getTag(tag, list) {
      return list.filter(item => item.MIGX_id === tag)[0].label;
    },
    getCurrent() {
      if (this.$store.state.initialData.currents) {
        const arr = this.$store.state.initialData.currents.filter(c => {
          if (
            typeof c.resource !== `undefined` &&
            c.resource.id === this.video.current
          ) {
            return true;
          }
          return false;
        });

        this.current = arr[0];
        // this.video.current = arr[0];
      }
    },
    getTeacher() {
      if (this.$store.state.initialData.teachers) {
        const arr = this.$store.state.initialData.teachers.filter(t => {
          if (t.id === this.video.videoTeacher) {
            return true;
          }
          return false;
        });

        this.teacher = arr[0];
      }
    },
    getEquipList() {
      const self = this;
      if (this.initialData.equipment) {
        this.initialData.equipment.forEach(t => {
          this.video.equip.forEach(item => {
            if (item.tag === t.id) {
              self.equipment.push(t);
            }
          });
        });
      }
    },
    setVideo(v) {
      this.video = v[0];
    },
    setData(video, error) {
      this.setVideo(video);
      this.$store.dispatch(`resetTeacherFeedback`);
      if (error) {
        this.$store.state.errors.push(error);
      }
    },
  },

  // created() {
  //   if (this.isLoggedIn === 0) {
  //     this.$router.push(`/profile`);
  //   }
  // },
};
</script>

<style lang="scss">
.columns.video-top-info {
  background-color: #ffffff;
  margin: 2rem auto;
  flex-wrap: wrap;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.25);
  border-radius: 3px;

  h1 {
    font-weight: bold;
  }

  svg {
    margin-right: 0.5rem;
    position: relative;
    top: 2px;
  }
  .level-icon {
    width: 16px;
    height: 16px;
    transform: rotateY(180deg);
  }
  .video-content {
    margin-top: 1.2rem;
    font-size: 1.125rem;
    color: #7c7c7c;
  }
  .video-tags {
    background: rgba(196, 196, 196, 0.14);
    padding: 0.5rem;
    width: 100%;
    .column {
      padding: 0;
    }
    .has-text-left {
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
    }

    .is-9 {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
    }
    .like-btn {
      display: inline-block;
      img {
        transform: scale(1.5);
      }
      position: relative;
      top: 9px;
      margin-left: 1rem;
    }
  }
  .result-tag {
    &:hover {
      .hash {
        display: inline-block;
      }
    }
  }
}
.more-videos {
  padding-top: 30px;
  padding-right: 15px;
  h2 {
    font-size: 24px;
    margin: 20px -15px 30px 0;
  }
  .video-item {
    margin: 0 0 15px 15px;
  }

  .load-more {
    margin-top: 2rem;
  }
}

.main-video-container {
  box-shadow: (4px 4px 8px rgba(0, 0, 0, 0.25));
  margin-top: 2rem;
}

@media screen and (min-width: 1408px) {
  .container.video-page-container {
    max-width: 1240px;
    width: 1240px;
  }
}

@media screen and (min-width: 769px) {
  .video-tags {
    display: flex;
  }
  .video-top-info {
    .result-tag {
      margin-bottom: 0;
    }
  }
}
</style>
